import { ApiKey } from "../../common/request/apiKey";
import { useApiTrigger } from "../../common/request/useApiTrigger";
import {
  UpdateSelectCreditCardRequest,
  UpdateSelectCreditCardResponse,
} from "./types";

export const useUpdateSelectCreditCardTrigger = () => {
  return useApiTrigger<
    UpdateSelectCreditCardResponse,
    UpdateSelectCreditCardRequest
  >({
    method: ApiKey.UPDATE_SELECT_CREDIT_CARD,
  });
};
